import ButtonCustomStyled from './styled'

interface ButtonProps {
  onClickButton: () => void
  buttonName: string | React.ReactNode
  disabled?: boolean
  width?: number
  btnCancel?: boolean
  isLoading?: boolean
  customClass?: string
}

function ButtonCustom({ onClickButton, buttonName, disabled, isLoading, customClass = '' }: ButtonProps) {

  const handleClick = () => {
    if (disabled || isLoading) return
    onClickButton()
  }

  return (
    <ButtonCustomStyled>
      <div onClick={handleClick}>
        <div className={`btn-container ${customClass}`}>
          <span className={`color-primary font-bold`}>{buttonName}</span>
        </div>
      </div>
    </ButtonCustomStyled>
  )
}

export default ButtonCustom
